<template>
  <div class="consider__plan__form">
    <div class="text-center mb-4">
      <div class="font-32 font-w-700 font-ch">
        {{this.$route.params.formType === "area-form" ? "แบบฟอร์มพิจารณา" : "แบบฟอร์มพิจารณาแผนงาน"}}
      
      </div>
      <div class="font-20 font-w-700 font-ch" style="color: #f7941d">
        (Consider Form)
      </div>
    </div>

    <div class="text-center font-20 font-w-500 font-ch px-16 mb-6" v-if="fiscalYear">
      {{(this.$route.params.formType === "area-form" ? "เกณฑ์การพิจารณาแบบฟอร์มคำร้องขอใช้พื้นที่" : getNameFromPlanCode()) + " ประจำปีงบประมาณ " + fiscalYear}}
    </div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card flat class="pa-6 section_form mb-3">
        <v-layout align-center class="font-14 font-w-500 font-ch">
          <v-flex shrink>
            <span class="mr-2">รหัสแผนงาน</span>
            <span class="text__orange">{{ form.plan_code }}</span>
          </v-flex>
          <v-flex shrink class="mx-12">
            <span class="text__orange">
              {{ form.plan_region }}
            </span>
          </v-flex>
          <v-flex shrink>
            <span>
              <span class="mr-2">ผู้พิจารณา</span>
              <span class="text__orange">{{ form.evaluator_name }}</span>
            </span>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <span>
              <span class="mr-2">วันที่</span>
              <span class="text__orange">{{ date }}</span>
            </span>
          </v-flex>
        </v-layout>
      </v-card>

      <!-- Table -->
      <v-card flat class="pa-4 section_form mb-3">
        <table class="custom_table">
          <thead>
            <tr>
              <th
                class="text-center font-12"
                style="border-right: thin solid #d3d3d3"
                width="5%"
              >
                ลำดับ
              </th>
              <th
                class="text-center font-12"
                style="border-right: thin solid #d3d3d3"
                width="70%"
              >
                ประเภท/รายละเอียด
              </th>
              <th
                class="text-center font-12"
                style="border-right: thin solid #d3d3d3"
                width="10%"
              >
                คะแนน
              </th>
              <th class="text-center font-12" width="25%">ผลการประเมิน</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, i) in form.details"
              :key="i"
              style="vertical-align: top"
            >
              <td
                class="text-center py-3"
                style="
                  border-right: thin solid #d3d3d3;
                  border-bottom: 1px solid #d3d3d3;
                "
                width="5%"
              >
                {{ i + 1 }}.
              </td>
              <td
                style="
                  border-right: thin solid #d3d3d3;
                  border-bottom: 1px solid #d3d3d3;
                "
                width="70%"
                class="py-3"
              >
                <!-- main detail -->
                <div style="min-height: 40px; height: auto">{{ item.plan_name }}</div>
                <!-- sub detail -->
                <div
                  style="min-height: 50px; height: auto"
                  v-for="(sub, j) in item.sub_details"
                  :key="j"
                  class="d-flex align-center"
                >
                  <div>
                    <span class="mr-2">{{ i + 1 }}.{{ j + 1 }}</span>
                    <span>{{ sub.name }}</span>
                  </div>
                </div>
              </td>
              <td
                class="text-center py-3"
                style="
                  border-right: thin solid #d3d3d3;
                  border-bottom: 1px solid #d3d3d3;
                "
                width="10%"
              >
                <!-- main detail -->
                <div style="min-height: 40px; height: auto" class="text__orange">
                  {{ item.max_score }}
                </div>
                <!-- sub detail -->
                <div
                  style="min-height: 50px; height: auto"
                  v-for="(sub, j) in item.sub_details"
                  :key="j"
                  class="text-center d-flex align-center justify-center"
                >
                  <span>{{ sub.max_score }}</span>
                </div>
              </td>
              <td
                class="text-center"
                width="25%"
                style="border-bottom: 1px solid #d3d3d3"
              >
                <!-- main detail -->
                <div style="min-height: 40px; height: auto">
                  <v-text-field
                    v-model="item.score"
                    outlined
                    dense
                    class="text-center"
                    hide-details
                    height="30"
                    type="number"
                    color="#D3D3D3"
                    style="border-radius: 30px"
                    :placeholder="item.sub_details.length > 0 ? '' : 'โปรดระบุ'"
                    :disabled="item.sub_details.length > 0"
                    :background-color="
                      item.sub_details.length > 0 ? '#FAFAFA' : ''
                    "
                    :rules="[
                        v => !!v || 'กรุณาระบุรหัสแผนงาน',
                        v => (v <= item?.max_score) || `คะแนนต้องไม่เกิน ${item?.max_score}`
                      ]"
                    required
                  ></v-text-field>
                </div>
                <!-- sub detail -->
                <div
                  style="min-height: 50px; height: auto"
                  v-for="(sub, j) in item.sub_details"
                  :key="j"
                  class="text-center d-flex align-center"
                >
                  <v-text-field
                    v-model="sub.score"
                    placeholder="โปรดระบุ"
                    outlined
                    dense
                    class="text-center"
                    type="number"
                    hide-details
                    height="30"
                    color="#D3D3D3"
                    style="border-radius: 30px"
                    :rules="[
                        v => !!v || 'กรุณาระบุรหัสแผนงาน',
                        v => (v <= sub?.max_score) || `คะแนนต้องไม่เกิน ${sub?.max_score}`
                      ]"
                    required
                    @input="calculateTotalScore(i, j, sub.score)"
                  ></v-text-field>
                </div>
              </td>
            </tr>

            <tr>
              <td style="border-right: thin solid #d3d3d3"></td>
              <td style="border-right: thin solid #d3d3d3" class="text-center">
                <span class="mr-2">คะแนนรวม</span>
              </td>
              <td style="border-right: thin solid #d3d3d3" class="text-center">
                <span class="text__orange">{{ form.overall_score }}</span>
              </td>
              <td class="text-center">
                <span class="text__orange">{{ form.total_score }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </v-card>

      <!--  ความคิดเห็น/ข้อเสนอเเนะ -->
      <v-card flat class="pa-4 section_form mb-3">
        <div class="font-14 font-w-500 font-ch mb-2">
          ความคิดเห็น/ข้อเสนอเเนะ
        </div>
        <v-textarea
          v-model="form.feedback"
          outlined
          dense
          rows="5"
          color="#D3D3D3"
          style="border-radius: 30px ;"
          placeholder="โปรดระบุ"
          :rules="[(v) => !!v || 'กรุณาระบุความคิดเห็น/ข้อเสนอเเนะ']"
          required
        ></v-textarea>
      </v-card>

      <div class="font-14 font-w-500 font-ch mb-5" style="color: #f15a29">
        หมายเหตุ : แบบประเมินหากทำการลงคะเเนนแล้วไม่สามารถแก้ไขได้
      </div>

      <v-layout justify-space-between align-center>
        <v-flex shrink>
          <v-btn
            width="100"
            height="35"
            depressed
            rounded
            color="#D9D9D9"
            @click="cancelled()"
          >
            <span class="font-14 font-w-700 font-ch">ยกเลิก</span>
          </v-btn>
        </v-flex>
        
        <v-flex shrink>
          <v-btn
            width="120"
            height="35"
            dark
            rounded
            class="btn_yellow mr-5"
            @click="submitForm('Draft')"
            :loading="loadingBtn"
          >
            <span class="font-14 font-w-700 font-ch ">
        บันทึกฉบับร่าง
            </span>
          </v-btn>
          <v-btn
            width="120"
            height="35"
            dark
            rounded
            class="btn_orange_gradient"
            @click="submitForm('Submitted')"
            :loading="loadingBtn"
          >
            <Icon icon="fluent:mail-edit-24-filled" style="color: #ffffff" />
            <span class="font-14 font-w-700 font-ch ml-2">
        {{this.$route.params.formType === "area-form" ? "Submitted" : "พิจารณา"}}
              
              
            
            </span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog v-model="dialog" width="500" >
      <v-card class="pa-6">
        <div style="display: flex; justify-content: center; align-items: center; width:100%;  ">
          <div style="display: flex; justify-content: center; width:50px;height:50px; background-color: var(--theme-color-two);padding:6px; border-radius: 4px; ">
          <!-- icon success -->
          <Iconify  icon="material-symbols:menu-book-sharp" color="white" size="40px"></Iconify>
          </div>
      </div>

        <div class="font-24 font-w-700 font-ch text-center mt-6">
          {{ dialogMsg }}
        </div>
        <div class="font-18 font-w-500 font-ch text-center mt-6">
          {{ dialogDesc }}
        </div>

        <!--TODO: เพิ่มปุ่ม บันทึกฉบับร่าง (เฉพาะ area-form type)-->
        
        <div class="d-flex justify-center mt-8  ">
          <Button
          class='mr-5'
          theme="3" height="36px" @onClick="dialog = false"
          >
            <div class="font-16 font-w-700 font-ch text-center">ยกเลิก</div>
          </Button>
          <Button
          theme="1" height="36px" @onClick="confirmSubmit('Submitted')"
          >
            <div class="font-16 font-w-700 font-ch text-center">ตกลง</div>
          </Button>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDraft" width="500">
      <v-card class="pa-6">
        <div style="display: flex; justify-content: center; align-items: center; width:100%;  ">
          <div style="display: flex; justify-content: center; width:50px;height:50px; background-color: var(--theme-color-two);padding:6px; border-radius: 4px; ">
          <!-- icon success -->
          <Iconify  icon="material-symbols:menu-book-sharp" color="white" size="40px"></Iconify>
          </div>
      </div>


        <div class="font-24 font-w-700 font-ch text-center mt-6">
          {{ dialogDraftMsg }}
        </div>
        <div class="font-18 font-w-500 font-ch text-center mt-6">
          {{ dialogDesc }}
        </div>
        <!--TODO: เพิ่มปุ่ม บันทึกฉบับร่าง (เฉพาะ area-form type)-->
        
        <div class="d-flex justify-center mt-8 ">
          <Button
          class='mr-5'
          theme="3" height="36px" @onClick="dialogDraft = false"
          >
            <div class="font-16 font-w-700 font-ch text-center">ยกเลิก</div>
          </Button>
          <Button
          theme="1" height="36px" @onClick="confirmSubmit('Draft')"
          >
            <div class="font-16 font-w-700 font-ch text-center">ตกลง</div>
          </Button>
        
        </div>
      </v-card>
    </v-dialog>
    <!-- <pre>
        {{ form }}
    </pre> -->
  </div>
</template>

<script>
import Service from "../../services";
import { Icon } from "@iconify/vue2";
import moment from "moment";
import Button from "@/components/input/Button";
import { id } from "date-fns/locale";

export default {
  name: "EvaluateForm",
  components: {
    Icon,
    Button
  },
  data() {
    return {
      date: moment().add(543, "year").format("DD/MM/YYYY"),
      valid: true,
      loadingBtn: false,
      isUpdated: false,
      evaluateID: null,
      dialog: false,
      dialogDraft: false,
      dialogMsg: "บันทึกข้อมูล ?",
      dialogDraftMsg: "บันทึกฉบับร่าง ?",
      dialogDesc: "กรุณาตรวจสอบข้อมูลของท่านให้ครบถ้วน ก่อนกดปุ่มยืนยัน",
      fiscalYear: null,
      form: {
        layout_id: null,
        plan_id: null,
        form_b_id: null,
        plan_code: null,
        plan_region: null,
        evaluator_id: null,
        evaluator_name: null,
        evaluate_date: moment().format("YYYY-MM-DD"),
        overall_score: 0,
        total_score: 0,
        feedback: null,
        details: [
          //   {
          //     consider_id: null,
          //     plan_name: null,
          //     max_score: null,
          //     score: null,
          //     sub_details: [
          //       {
          //         name: null,
          //         max_score: null,
          //         score: null,
          //       },
          //     ],
          //   },
        ],
      },
    };
  },
  computed: {
    user: function () {
      return this.$store.state.Auth.User;
    },
  },
  created() {
    //use this.form.area_form_id = this.$route.params.id; instead in type area-form
    if (this.$route.params.formType === "form-b"){
      this.form.form_b_id = this.$route.params.id;
    }else {
      this.form.area_form_id = this.$route.params.id;
    }
    this.fetchForm();
  },
  watch: {
    form: {
      handler: function (val) {
        // console.log(val);
        // sum score details and sub_details
        if (this.form.details.length > 0) {
          this.form.total_score = this.form.details.reduce((acc, cur) => {
            return acc + +cur.score;
          }, 0);
        }
      },
      deep: true,
    },
  },
  methods: {
    async fetchForm() {
      //TODO: condition route params.form_type = 'form-b' || = 'area-form
      //TODO: เปลี่ยนเส้น api สำหรับ area-form
      if (this.$route.params.formType === "area-form") {
        const res = await this.$apiFire(
          "Consider/getEvaluateAreaForm",
          this.$route.params.id
        );
        console.log("fetchForm", res);
        if (res) {
          const areaForm = res.areaForm;
          this.fiscalYear = areaForm.year;
          const layout = res.layout;
          const evaluateForm = res?.evaluateForm;
          this.isUpdated = evaluateForm !== null ? true : false;
          this.evaluateID = res?.evaluateForm?.id;
          //TODO: in area-form type formB is null use layout instead of formB?.plan?.evaluate_layout
          //TODO: in area-form type formB is null use areaForm instead of formB
          this.form.layout_id = layout?.id;
          // don't have plan id in area-form
          this.form.plan_id = areaForm?.id;
          this.form.plan_code = layout?.plan_code;
          this.form.plan_region = areaForm?.area_group?.region;
          this.form.evaluator_name = this.user?.name
            ? this.user?.name
            : "Unknown User";
          this.form.evaluator_id = this.user?.id ? this.user?.id : 1;
          this.form.overall_score = layout?.overall_score;
          if (layout?.details) {
            this.form.details = layout?.details.map(
              (item) => {
                return {
                  plan_name: item.name,
                  max_score: item.max_score,
                  score: null,
                  sub_details: item.sub_details.map((sub) => {
                    return {
                      name: sub.name,
                      max_score: sub.max_score,
                      score: null,
                    };
                  }),
                };
              }
            );
          }
          if (evaluateForm?.details) {
            this.form.details = evaluateForm?.details.map(
              (item) => {
                return {
                  plan_name: item.plan_name,
                  max_score: item.max_score,
                  score: item.score,
                  id: item.id,
                  sub_details: item.sub_details.map((sub) => {
                    return {
                      name: sub.name,
                      id: sub.id,
                      max_score: sub.max_score,
                      score: sub.score,
                    };
                  }),
                };
              }
            );
          }
          this.form.feedback = evaluateForm?.feedback;
        } 
      }else if (this.$route.params.formType === "form-b") {
        const res = await this.$apiFire(
          "Consider/getEvaluateForm",
          this.$route.params.id
        );
        console.log("fetchForm", res);
        if (res) {
          const formB = res.formB;
          this.fiscalYear = formB.fiscal_year;
          // set data to form
          this.form.layout_id = formB?.plan?.evaluate_layout?.id;
          const evaluateForm = res?.evaluateForm;
          this.isUpdated = evaluateForm !== null ? true : false;
          this.evaluateID = res?.evaluateForm?.id;
          // don't have plan id in area-form
          this.form.plan_id = formB?.plan?.id;
          this.form.plan_code = formB?.plan?.evaluate_layout?.plan_code;
          this.form.plan_region = formB?.region;
          this.form.evaluator_name = this.user?.name
            ? this.user?.name
            : "Unknown User";
          this.form.evaluator_id = this.user?.id ? this.user?.id : 1;
          this.form.overall_score = formB?.plan?.evaluate_layout?.overall_score;
          if (formB?.plan?.evaluate_layout?.details) {
            this.form.details = formB?.plan?.evaluate_layout?.details.map(
              (item) => {
                return {
                  plan_name: item.name,
                  max_score: item.max_score,
                  score: null,
                  sub_details: item.sub_details.map((sub) => {
                    return {
                      name: sub.name,
                      max_score: sub.max_score,
                      score: null,
                    };
                  }),
                };
              }
            );
          }
          if (evaluateForm?.details) {
            this.form.details = evaluateForm?.details.map(
                (item) => {
                  return {
                    plan_name: item.plan_name,
                    max_score: item.max_score,
                    score: item.score,
                    id: item.id,
                    sub_details: item.sub_details.map((sub) => {
                      return {
                        name: sub.name,
                        id: sub.id,
                        max_score: sub.max_score,
                        score: sub.score,
                      };
                    }),
                  };
                }
            );
            console.log('this.formB.details', this.form.details);
          }
          this.form.feedback = evaluateForm?.feedback;
        }
      }
   
    },
    async submitForm(type) {
      if (type === "Submitted") {
        if (this.$refs.form.validate()) {
          this.dialog = true;
        }
      } else if (type === "Draft") {
        this.dialogDraft = true;
      }
    },
    async confirmSubmit(type) {
      console.log(this.isUpdated,'this.isUpdated');
      
      //TODO: แยกระหว่าง Draft กับ Submitted ในเรื่องการส่ง status ไป api และ ถ้าเป็น Draft ไม่ต้อง validate
      if (type === 'Submitted' && this.isUpdated === false) {
          this.dialog === false
        if (this.$refs.form.validate()) {
          const submitForm = { ...this.form,
            status: 'Submitted',
          };
          const res = await this.$apiFire("Consider/saveEvaluateForm", submitForm);
          if (res) {
            if (this.$route.params.formType === "area-form") {
              this.$router.push("/evaluate-request");
            }else{ 
              this.$router.push("/evaluate-list");
            }
          }
        }
      }
      else  if (type === 'Submitted' && this.isUpdated === true){
        this.dialogDraft === false

        const draftForm = { ...this.form ,
          status: 'Submitted',
          evaluateID: this.evaluateID
         };
        const res = await this.$apiFire("Consider/draftEvaluateForm", draftForm);
          console.log("fetchForm", res);
          if (res) {
            if (this.$route.params.formType === "area-form") {
              this.$router.push("/evaluate-request");
            }else{ 
              this.$router.push("/evaluate-list");
          }
      }
    }
      else  if (type === 'Draft' && this.isUpdated === true){
        this.dialogDraft === false

        console.log("submitForm", this.form);
        const draftForm = { ...this.form ,
          status: 'Draft',
          evaluateID: this.evaluateID
         };
        const res = await this.$apiFire("Consider/draftEvaluateForm", draftForm);
          console.log("fetchForm", res);
          if (res) {
            if (this.$route.params.formType === "area-form") {
              this.$router.push("/evaluate-request");
            }else{ 
              this.$router.push("/evaluate-list");
          }
      }
    }
    else  if (type === 'Draft' && this.isUpdated === false){
        this.dialogDraft === false
        console.log("submitForm false", this.form);
        const draftForm = { ...this.form ,
          status: 'Draft',
         };
        const res = await this.$apiFire("Consider/saveEvaluateForm", draftForm);
          console.log("fetchForm", res);
          if (res) {
            if (this.$route.params.formType === "area-form") {
              this.$router.push("/evaluate-request");
            }else{ 
              this.$router.push("/evaluate-list");
            }
      }
    }
    },
    calculateTotalScore(mainIndex, subIndex, val) {
      console.log(mainIndex, subIndex, val);
      // sum max score in details to overall score
      this.form.details[mainIndex].score = this.form.details[
        mainIndex
      ].sub_details.reduce((acc, cur) => {
        return acc + +cur.score;
      }, 0);

      this.form.details[mainIndex].score =
        this.form.details[mainIndex].score == 0
          ? null
          : this.form.details[mainIndex].score;
    },
    cancelled() {
      if (this.$route.params.formType === "area-form") {
        this.$router.push("/evaluate-request");
      }else{
        this.$router.push("/evaluate-list");
        
      }
    },
    getNameFromPlanCode() {
      switch(this.form.plan_code) {
        case 'IRTC':
          return 'แผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่ (IRTC)';
        case 'STI':
          return 'แผนงานบ่มเพาะธุรกิจวิทยาศาสตร์ เทคโนโลยีและนวัตกรรม (STI)';
        case 'SP':
          return 'แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์ (SP)';
        case 'CR':
          return 'แผนงานวิจัยร่วมกับภาคเอกชน (CR)';
        case 'RSPM':
          return 'แผนงาน RSP Management';
        case 'AREA':
          return 'แผนงานบริหารจัดการอาคาร';
        default:
          return 'แบบฟอร์มไม่รู้จัก';
      }
    }
  },
};
</script>

<style lang="scss">
.consider__plan__form {
  .section_form {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1) !important;
    border-radius: 20px;
  }
  .text__orange {
    color: #f15a29;
  }
  .custom_table {
    border: thin solid #d3d3d3;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }
  .btn_orange_gradient {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #FBB040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px; 
  }
  .btn_yellow {
    background: linear-gradient(21.01deg, #FBB040 6.18%, #FBB040 84.83%);
    border-radius: 30px;
  }
  .v-text-field__slot {
    input {
      text-align: center !important;
    }
  }
  .custom_table {
    width: 100%;
    border-spacing: 0px;
    th {
      padding: 10px;
      border-bottom: 1px solid #d3d3d3;
    }
    td {
      padding: 10px;
    }
  }
}
</style>
